import React, { useCallback, useEffect, useRef, useState } from "react";
import classes from "./ApplyFormFromExisting.module.scss";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import Divider, { dividerClasses } from "@mui/material/Divider";

import DialogButton from "./DialogButton";
import { HorizontalRule as HorizontalRuleIcon } from "@mui/icons-material";
import { ErrorModal } from "../atoms/ErrorModal";
import { useRecoilValue } from "recoil";
import { userState } from "../../../states/userState";
import { backColorModal, backGroundColorCode } from "../../../commons/colors";
export const ApplyFormExisting = (props) => {
  const { setIsShow, data } = props;
  const user = useRecoilValue(userState);
  const isDisabled = true;
  //エラーダイアログの表示
  const [isShowErrorDialog, setIsShowErrorDialog] = useState(false);
  const [title, setTitle] = useState("バリデーションエラー");
  const [message, setMessage] = useState("入力内容が不正です");
  //ダイアログの操作
  const [open, setOpen] = useState(true);
  //キャンセル
  const handleCancelButtonClick = () => {
    // setSendArray([]);
    setOpen(false);
    setIsShow(false);
  };
  //更新
  const handleAddButtonClick = () => {};
  //デバッグ
  useEffect(() => {
    data && console.log("data", data);
  }, [data]);
  const handleOpenUrl = (url) => {
    window.open(url, "_blank");
  };
  const inputEditStyle = (name) => {
    let styles = {
      // backgroundColor: "#37393f",
      backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
      borderRadius: "5px",
      "& .MuiInputBase-input": {
        color: "primary.main", // 入力文字の色
      },
      //スピンボタンの無効化-効いていない
      ':global(input[type="number"]::-webkit-outer-spin-button)': {
        WebkitAppearance: "none",
        margin: 0,
      },
      ':global(input[type="number"]::-webkit-inner-spin-button)': {
        WebkitAppearance: "none",
        margin: 0,
      },

      "& .MuiInputBase-input": {
        color: "primary.main", // テキストフィールド内のフォントカラーをプライマリーカラーに
        fontSize: "16px",
        // その他のスタイル設定...
      },
      "& label": {
        color: "primary.main", // 通常時のラベル色
        //backgroundColor:"white"
      },
      "& label.Mui-focused": {
        color: "primary.main", // ラベルの色をprimary.mainに指定
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: "primary.main", // 通常時のボーダー色
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: "primary.main", // ホバー時のボーダー色
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "primary.main", // 通常時のボーダー色(アウトライン)
        },
        "&:hover fieldset": {
          borderColor: "primary.main", // ホバー時のボーダー色(アウトライン)
        },
        "& .MuiInputBase-root": {},
      },
    };
    switch (name) {
      case "workerNo":
        styles.width = "100px";
        //tyles["WebkitOuterSpinButton"] ={ WebkitAppearance: "none" }
        //styles["WebkitInnerSpinButton"] ={ WebkitAppearance: "none" }
        break;
      case "fileName":
        //styles.fontSize="10px";
        styles["& .MuiInputBase-input"].fontSize = "12px";
        styles.width = "160px";

        styles["& .MuiInputBase-root"] = {
          height: "60px", // 固定高さを設定
          // overflowY: "auto", // 内容がオーバーフローしたらスクロールバーを表示
        };
        break;
      case "url":
        //styles.fontSize="10px";
        styles["& .MuiInputBase-input"] = {
          fontSize: "12px",
          color: "blue",
          "&:hover": {
            color: "#ff0", // ホバー時のテキスト色を黄色に変更
          },
        };
        styles.width = "160px";
        styles["& .MuiInputBase-root"] = {
          height: "60px", // 固定高さを設定
          overflowY: "hidden", // 縦方向のオーバーフローを非表示にする
          whiteSpace: "nowrap", // テキストを折り返さずに一行で表示
          textOverflow: "ellipsis", // オーバーフローしたテキストを省略記号で表示
          "&:hover": {
            color: "#ff0", // ホバー時のテキスト色を黄色に変更
          },
        };
        break;
      case "remarks":
        //styles.fontSize="10px";
        styles["& .MuiInputBase-input"].fontSize = "12px";
        styles.width = "160px";
        styles["& .MuiInputBase-root"] = {
          height: "80px", // 固定高さを設定
          // overflowY: "auto", // 内容がオーバーフローしたらスクロールバーを表示
        };
        break;
      default:
        break;
    }
    return styles;
  };
  const inputReadOnlyStyle = (name) => {
    let styles = {
      "&&&": {
        margin: "10px",
        color: "primary.main",
        width: "230px",
        margin: "0 0 0 0",
        // backgroundColor:"#dedede",
      },
      "& input": {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: "5px",
        fontSize: "14px",
        height: "38px",
        color: "primary.main",
        border: "1px solid primary.main",
        textAlign: "center",
        borderRadius: "5px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .MuiInputBase-input": {
        color: "primary.main", // 入力文字の色
        // backgroundColor: "#37393F",
        backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
      },
      "& label": {
        color: "primary.main", // 通常時のラベル色
        //backgroundColor:"white"
      },
      "& label.Mui-focused": {
        color: "primary.main", // ラベルの色をprimary.mainに指定
      },
      "& .MuiInput-underline:before": {
        borderBottomColor: "primary.main", // 通常時のボーダー色
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: "primary.main", // ホバー時のボーダー色
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "primary.main", // 通常時のボーダー色(アウトライン)
        },
        "&:hover fieldset": {
          borderColor: "primary.main", // ホバー時のボーダー色(アウトライン)
        },
      },
    };
    switch (name) {
      case "recordNo":
        styles["&&&"].width = "100px";
        break;
      case "productNo":
        styles["&&&"].width = "120px";
        break;
      case "update":
        styles["&&&"].width = "140px";
        break;
      case "tabName":
        styles["&&&"].width = "100px";
        styles["& input"].fontSize = "12px";
        break;
      case "displayOrder":
        styles["&&&"].width = "80px";
        break;
      case "rev":
        styles["&&&"].width = "60px";
        break;
      case "latest":
        styles["&&&"].width = "60px";
        break;
      case "preceding":
        styles["&&&"].width = "80px";
        break;
      case "inspection":
        styles["&&&"].width = "60px";
        break;
      case "inspectionDate":
        styles["&&&"].width = "100px";
        break;
      default:
        break;
    }
    return styles;
  };

  const dividerStyle = (name) => {
    let styles = {
      borderColor: "primary.main", // 線の色をテーマのプライマリーカラーに設定
      fontSize: "18px",
      marginBottom: "0px",
      // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
      "&::before, &::after": {
        // Dividerの線のスタイルをカスタマイズ
        borderTopColor: "primary.main", // これにより、線の色が変わります
      },
      color: "primary.main", // テキストの色を変更
    };
    switch (name) {
      case "readOnly":
        styles.borderColor = "primary.main";
        styles.color = "primary.main";
        styles["&::before, &::after"].borderTopColor = "primary.main";
        break;
      case "edit":
        styles.borderColor = "error.main";
        styles.color = "primary.main";
        styles["&::before, &::after"].borderTopColor = "error.main";
        break;
      default:
        break;
    }
    return styles;
  };
  const inputStyle = (name) => {
    let styles = {
      "&&&": {
        margin: "10px",
        color: "primary.main",
        width: "80px",
        margin: "0 0 0 0",
        backgroundColor: "#dedede",
      },
      "& label": {
        color: "primary.main",
        fontSize: "16px",
        //backgroundColor:"#dedede",
      },
      "& svg": {
        color: "primary.main",
      },
      "& input": {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: "5px",
        fontSize: "14px",
        height: "38px",
        color: "black",
        border: "1px solid #a0a0a0",
        textAlign: "center",
        borderRadius: "5px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
        borderBottomColor: "#CCCCCC", // ホバー時のボーダー色
        color: "#a0a0a0",
        //border: "none",
      },
      "& .MuiOutlinedInput-root": {
        color: "#a0a0a0",
        "&:hover fieldset": {
          borderColor: "#CCCCCC", // ホバー時のボーダー色(アウトライン)
          //border:"none",
        },
      },
      // 入力部分のスタイル
      "& .MuiInputBase-input": {
        color: "black", // テキストフィールド内のフォントカラーをプライマリーカラーに
        // その他のスタイル設定...
      },
    };
    switch (name) {
      case "workerName":
        styles["&&&"].width = "150px";
        break;
      case "division":
        styles["&&&"].width = "100px";
        break;
      case "department":
        styles["&&&"].width = "150px";
        break;
      case "date":
        styles["&&&"].width = "110px";
        break;
      case "hourMin":
        styles["&&&"].width = "120px";
        break;
      case "time":
        styles["&&&"].width = "110px";
        break;
      case "break30":
        styles["&&&"].width = "80px";
        break;
      case "meal":
        styles["&&&"].width = "150px";
        break;
      case "reason":
        styles["&&&"].width = "200px";
        styles["& .MuiInputBase-root"] = {
          height: "100px", // 固定高さを設定
          overflow: "auto", // 内容がオーバーフローしたらスクロールバーを表示
        };
        styles["& .MuiOutlinedInput-input"] = {
          height: "100px", // 固定高さを設定
          //height: 'calc(100% - 30px)',
          overflow: "auto", // 内容がオーバーフローしたらスクロールバーを表示
        };
        break;
      case "datetime":
        styles["&&&"].width = "150px";
        break;
      case "address":
        styles["&&&"].width = "240px";
        break;
      default:
        styles["&&&"].width = "100px";
        break;
    }
    return styles;
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleCancelButtonClick}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          borderColor: "prmary.main",
          "&:focus-visible": {
            borderColor: "prmary.main",
            outlineColor: "primary.main", // Assuming your theme's primary.main is the color you want
          },
        }}
      >
        <div
          className={classes.formContainer}
          style={backColorModal(user?.mode ?? "lite")}
        >
          {/* <h1>レコード詳細</h1> */}

          <Divider
            textAlign="left"
            sx={dividerStyle("readOnly")}
            variant="fullWidth"
          >
            レコード情報
          </Divider>
          <div className={classes.baseContents}>
            <div>
              <TextField
                label="レコード番号"
                variant="outlined"
                value={data["レコード番号"]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("recordNo")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div>
            <div>
              <TextField
                label="更新日時"
                variant="outlined"
                value={data["更新日時"]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("update")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div>
            <div>
              <TextField
                label="製作番号"
                variant="outlined"
                value={data["製番"]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("productNo")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div>
            <div>
              <TextField
                label="ファイル名"
                variant="outlined"
                value={data["ファイル名"]}
                // error={errorReason.isShow}
                // required={true}
                // helperText={errorReason.text}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputEditStyle("fileName")}
                multiline={true}
                // disabled={isDisabled}
              />
            </div>
            <div>
              <TextField
                label="URL(別ﾀﾌﾞで開く)"
                variant="outlined"
                value={
                  data["URL"].length > 36
                    ? data["URL"].slice(0, 36) + "..."
                    : data["URL"]
                }
                // error={errorReason.isShow}
                // required={true}
                // helperText={errorReason.text}
                InputProps={{
                  readOnly: true,
                  // TextField全体ではなく、入力部分にのみクリックイベントを適用
                  inputProps: {
                    onClick: () => handleOpenUrl(data["URL"]),
                    style: { cursor: "pointer" }, // カーソルをポインタに変更してクリック可能であることを示す
                  },
                }}
                InputLabelProps={{ shrink: true }}
                sx={inputEditStyle("url")}
                multiline={true}
                // disabled={isDisabled}
              />
            </div>
          </div>
          <Divider
            textAlign="left"
            sx={dividerStyle("readOnly")}
            variant="fullWidth"
          >
            属性情報
          </Divider>
          <div className={classes.attribute}>
            <div>
              <TextField
                label="タブ名図面名"
                variant="outlined"
                value={data["タブ名図面名"]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("tabName")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div>
            <div>
              <TextField
                label="表示順"
                variant="outlined"
                value={data["表示順"]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("displayOrder")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div>
            <div>
              <TextField
                label="rev"
                variant="outlined"
                value={data["rev"]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("rev")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div>
            <div>
              <TextField
                label="最新"
                variant="outlined"
                value={data["最新フラグ"]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("latest")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div>
            {/* <div>
              <TextField
                label="先行手配"
                variant="outlined"
                value={data["先行手配"][0]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("preceding")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div> */}
            <div>
              <TextField
                label="検査"
                variant="outlined"
                value={data["検査"]}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputReadOnlyStyle("inspection")}
                // helperText={errorWorkerName.text}
                // disabled={isDisabled}
                // error={errorWorkerName.isShow}
              />
            </div>
            <div>
              <TextField
                label="備考"
                variant="outlined"
                value={data["備考"]}
                // error={errorReason.isShow}
                // required={true}
                // helperText={errorReason.text}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputEditStyle("remarks")}
                multiline={true}
                // disabled={isDisabled}
              />
            </div>
            <div>
              <TextField
                label="コメント"
                variant="outlined"
                value={data["コメント"]}
                // error={errorReason.isShow}
                // required={true}
                // helperText={errorReason.text}
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                sx={inputEditStyle("remarks")}
                multiline={true}
                // disabled={isDisabled}
              />
            </div>
          </div>
          <div className={classes.buttonContainer}>
            {!isDisabled && (
              <div className={classes.buttons}>
                <DialogButton
                  label={"更新"}
                  disabled={false}
                  onClick={handleAddButtonClick}
                  colorStyle={"yesColor"}
                />
              </div>
            )}
            <div className={classes.buttons}>
              <DialogButton
                label={"閉じる"}
                disabled={false}
                onClick={handleCancelButtonClick}
                colorStyle={"noColor"}
              />
            </div>
          </div>
        </div>
      </Modal>
      {isShowErrorDialog && (
        <ErrorModal
          title={title}
          message={message}
          setIsShow={setIsShowErrorDialog}
        />
      )}
    </>
  );
};
